import moment from 'moment'
import React, { useState, useEffect,useRef } from 'react'

import { Attendance,FR } from '../../sdk'
import { Loader } from '../Default'

import { DataTable2 } from '../Default/DataTables/DataTable2'
import { useAuthContext } from '../../context/Auth/Create'
export const DateWiseSearch = () => {
  const userAuth=useAuthContext()
  const [state, setState] = useState({ loader: true, year:new Date().getFullYear(),month:Number(new Date().getMonth()) +1, data: [], tableLoader: false ,
  tbHeader:[{title:"Month",data:"_id",render:function(data,type,row){
    return moment({year:ref4.current.year,month:ref4.current.month -1}).format("YYYY-MM");
  }},{title:"employeeId",data:"_id"},{title:"Name",data:"_id",render:function(data,type,row){
    return row.employeeName?row.employeeName:""
  }},{title:"Company Name",data:"_id",render:function(data,type,row){
    return row.companyName?row.companyName:"N/A"
  }},{title:"Department",data:"department"},{title:"Required Hours",data:"_id",render:function(data,type,row){
    return convertHoursToHHMM(row.totalRequiredHours);
  
  }},{title:"Worked Hour",data:"_id",render:function(data,type,row){
    return convertHoursToHHMM(row.workedHours)
  }},{title:"Required Days",data:"requiredDays"},{title:"Worked Days",data:"workedDays"},{title:"Excess/ShortTime",data:"_id",render:function(data,type,val){
    
    let shortExactTime=convertHoursToHHMM(Number(val.totalRequiredHours) - Number(val.workedHours))
    
    return shortExactTime?val.totalRequiredHours > val.workedHours?`-${shortExactTime}`:shortExactTime:"nil"
  }}],
  companyName:userAuth.user.isHightAuthority?userAuth?.user.companyName:"",
  department:"",
  companies:[],
  departments:[],
  }
);
  const ref4=useRef({
    year:new Date().getFullYear(),
    companyName:userAuth.user.isHightAuthority?userAuth?.user.companyName:"",
    department:"",
    companies:[],
    departments:[],
    month:Number(new Date().getMonth()) +1,
    dataTable1Params:{
      draw:1,
      start:0,
      length:0,
      search:"",
      order:"",
      columns:"",
      sort:"asc",
      actualData:[],

    },
   });
  const onHandler=(event)=>{
    let key=event.target.name;
    let value=event.target.value;
    ref4.current={...ref4.current,[key]:value}
   setState((pre)=>{
    return {...pre,[key]:value}
   })
   }

  function convertHoursToHHMM(seconds) {
  
    const duration = moment.duration(Math.abs(seconds), 'seconds');
      const formattedTime = `${Math.floor(duration.asHours()).toString().padStart(2, '0')}:${duration.minutes().toString().padStart(2, '0')}:${duration.seconds().toString().padStart(2, '0')}`;
      return formattedTime;
    }
  
  const apiDataWithPagination = async (data,callBack,year=ref4.current.year,month=ref4.current.month,companyName=ref4.current.companyName,department=ref4.current.department) => {
    try {
      setState((pre)=>{
       return {...pre,tableLoader:true}
      })
    
       
     let apiData = {
       draw:data?.draw,
       start:data?.start,
       length:data?.length,
       search:data?.search?.value || "",
       order:data?.order,
       columns:data?.columns,
       sort:data?.sort,
       year,month,companyName,department
       
             
     }
     
     let users=await new Attendance().monthlyWiseDataWithPagination({...apiData});
     ref4.current={...ref4.current,year,month,dataTable1Params:{
       draw:data?.draw,
       start:data?.start,
       length:data?.length,
       search:data?.search?.value || "",
       order:data?.order,
       columns:data?.columns,
       sort:data?.sort,
       actualData:users.data
     },
     callBack
     }
     ref4.current.callBack(users);
    
 
     setState((pre)=>{
       return {...pre,tableLoader:false,actualData:users.data}
      })
   } catch (e) {
     console.log(e)
     alert("error occur")
   }

  }
  const apiData=async()=>{
    try{
    let users=await new FR().getCompanies();
    let departments=[]
		let find=users.find(val=>val.companyName===state.companyName);
			if(find){
			 departments=find.departments;
			}
		
		setState((pre)=>{
		  return {...pre,companies:users,loader:false,departments}
	   })
   }catch(e){
    console.log(e)
    alert("error occur")
    }

}
const onHandlerType=(event)=>{
  let key=event.target.name;
  let value=event.target.value;
  if(key==="companyName"){
  let departments=[];
  let find=state.companies.find(val=>val.companyName===value);
  if(find){
   departments=find.departments;
  }
  ref4.current={...ref4.current,[key]:value,department:""}
  setState((pre)=>{
    return{...pre,departments,department:""}
  })
  }
  else{
   ref4.current={...ref4.current,[key]:value}
   setState((pre)=>{
     return{...pre,[key]:value}
   })
  }
 }
useEffect(()=>{
  apiData();
  },[])
 
  const months=[
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec"
  ]
  if (!state.loader) {
    return (
      <>
        <div className="card mb-3">
          {/* BEGIN card-body */}
          <div className="card-body">
          <div className="d-flex fw-bold small mb-3 row" style={{textAlign:"center"}}>
                  <div className="col-12">
                  <span className="flex-grow-1">Month wise Report</span>
                  </div>
                  {/* <div className="col-4">
                  <button type="button" class="btn btn-theme" onClick={()=>exportCsv("male-female")}>Export Csv</button>
                  </div> */}
                  <div className="col-2"></div>
                    <div className="col-sm-12 col-md-3 col-lg-2">
      <div class="form-group mb-3">
        <label class="form-label text-white fw-bold" for="exampleFormControlSelect1" ></label>
        <select class="form-select" name="companyName" id="exampleFormControlSelect1" onChange={onHandlerType} style={{color:"rgb(60, 210, 165)"}}>
          <option value="" selected={ref4.current.companyName===""}>Company</option>
          {state.companies.map((val,index)=>{
            return  <option key={index} value={val.companyName} selected={ref4.current.companyName===val.companyName}>{val.companyName}</option>
          })}
         
          
          </select>
          </div>
       </div>
       <div className="col-sm-12 col-md-3 col-lg-2">
      <div class="form-group mb-3" style={{width: "85%" }}>
        <label class="form-label text-white fw-bold" for="exampleFormControlSelect2" ></label>
        <select class="form-select" name="department" id="exampleFormControlSelect2" onChange={onHandlerType} style={{color:"rgb(60, 210, 165)"}}>
        <option value="" selected={ref4.current.companyName===""}>Department</option>
          {state.departments.map((val,index)=>{
            return  <option key={index} value={val} selected={ref4.current.department===val}>{val}</option>
          })}
          </select>
          </div>
       </div>
                  <div className="col-2">
                  <div class="form-group mb-3" >
                                            <label class="form-label" for="exampleFormControlSelect1"></label>
                                            <select class="form-select" name="year" onChange={onHandler} style={{color:"rgb(60, 210, 165)"}}>
                                             {Array(Number(new Date().getFullYear()) - 2022).fill(2023).map((v,index)=>{
                                              return (<>
                                                  <option value={Number(v) + Number(index)} selected={Number(new Date().getFullYear()) ===Number(v) + Number(index)}>{Number(v) + Number(index)}</option>
                                                  
                                                  </>)
                                             })}
                                            </select>
                                          </div>
                  </div>
                  <div className="col-2">
                  <div class="form-group mb-3" style={{width: "85%" }}>
                                            <label class="form-label" for="exampleFormControlSelect1"></label>
                                            <select class="form-select" name="month"  id="exampleFormControlSelect1" onChange={onHandler} style={{color:"rgb(60, 210, 165)"}}>
                                             {Array(12).fill(1).map((v,index)=>{
                                              return (<>
                                                  <option value={Number(v) + Number(index)} selected={Number(state.month -1) ===index}>{months[index]}</option>
                                                  
                                                  </>)
                                             })}
                                            </select>
                                          </div>
                  </div>
                   <div className="col-1" style={{marginTop:"19px"}}>
                    
                  <button type="button" class="btn btn-theme" onClick={()=>apiDataWithPagination({...ref4.current.dataTable1Params},ref4.current.callBack)}>Search</button>
                  </div>
                 
                  </div>

            {state.tableLoader && <><Loader/></>}
   
   <div className="col-12">
   {<DataTable2 headers={state.tbHeader} image={true}  reverse={true} count={"paginationTable8"} ajax={apiDataWithPagination} />}
  
   </div>
          </div>
          <div className="card-arrow">
            <div className="card-arrow-top-left" />
            <div className="card-arrow-top-right" />
            <div className="card-arrow-bottom-left" />
            <div className="card-arrow-bottom-right" />
          </div>
        </div>
        <div class="modal" id="showImg">
          <div class="modal-dialog modal-xl">
            <div class="modal-content">

              <div class="modal-body">
                <img id="modalImage" src='' alt="nothing" style={{ width: "100%" }} />
              </div>

            </div>
          </div>
        </div>


      </>


    )
  }
  else {

    return (<>
      <Loader />
    </>)
  }

}
